import { ApolloClient, InMemoryCache } from '@apollo/client';

export const BASE_URL = process.env.REACT_APP_WP_URL;

const client = new ApolloClient({
  uri: `${BASE_URL}graphql/`,
  cache: new InMemoryCache()
});

export default client;